import { makeStyles } from "@material-ui/core/styles";
export default makeStyles(theme => ({
  mousePosition: {
    alignSelf: "center",
    minWidth: "10%"
  },
  scaleLine: {
    minWidth: "10%"
  },
  scaleLinePad: {
    minWidth: "600px",
    paddingRight: "70px"
  },
  scale: {
    "& div.ol-scale-line": {
      marginTop: 0,
      padding: "0 !important",
      position: "relative !important"
    },
    "& div.ol-scale-line-inner": {
      ...theme.typography.body2,
      position: "absolute",
      inset: "0px",
      height: "18px",

      "&::before": {
        content: "''",
        position: "absolute",
        width: "100%",
        height: "1px",
        backgroundColor: "#eee",
        bottom: "0",
        left: "0"
      }
    }
  }
}));
